import React, { useState, useEffect } from 'react';
import { Button, CircularProgress } from '@mui/material';
import skillApis from '../../../apis/skills';
import DialogModal from '../../../components/DialogModal';
import { SnackbarSeverityType } from '../../../enums';
import { StyledButton } from '../../Exams/styled';
import TextInputWithIcon from '../../../components/TextInputWithIcon';
import { AddSkillModalProps } from '../types';

const AddSkillModal: React.FC<AddSkillModalProps> = ({
  open,
  onClose,
  academicYear,
  grade,
  division,
  school,
  onSkillAdded,
  showToast
}) => {
  const [skillName, setSkillName] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (open) {
      setSkillName('');
      setIsLoading(false);
    }
  }, [open]);

  const handleAddSkill = async () => {
    setIsLoading(true);
    try {
      await skillApis.upsertSkill(school, grade, division, {
        skillName,
        subSkills: [],
        academicYear
      });
      onSkillAdded();
      showToast('Skill added successfully!', SnackbarSeverityType.success);
    } catch (error) {
      console.error('Error adding skill:', error);
      showToast('Failed to add skill.', SnackbarSeverityType.error);
    } finally {
      setIsLoading(false);
    }
  };

  const isAddButtonDisabled = !skillName || isLoading;

  return (
    <DialogModal
      open={open}
      onClose={onClose}
      title='Add Skill'
      actions={
        <>
          <Button onClick={onClose} color='primary' variant='outlined'>
            Cancel
          </Button>
          <StyledButton onClick={handleAddSkill} disabled={isAddButtonDisabled}>
            {isLoading ? <CircularProgress size={24} color='inherit' /> : 'Add'}
          </StyledButton>
        </>
      }
    >
      <TextInputWithIcon
        label='Skill Name'
        placeholder='Enter Skill Name'
        required
        name='skillName'
        value={skillName}
        onChange={(e) => setSkillName(e.target.value)}
        fullWidth
      />
    </DialogModal>
  );
};

export default AddSkillModal;
